import React from 'react';
import styles from './App.module.css';
import { Routes, Route, Navigate,  } from 'react-router-dom';
import Hero from './Componets/Hero/Hero';
import Pricing from './Componets/Pricing/Pricing';
import Home from './Componets/Home';
import Navbar from './Componets/Navbar/Navbar';
import AudioController from './AudioController/AudioController';
import MusicAdmin from './MusicShare/MusicAdmin';
import MusicViewer from './MusicShare/MusicViewer';

const App = () => {
  return (
    <>
    <div className={styles.appContainer}>
      {/* <Navbar /> */}
       {/* <Home /> */}

      
      <Routes>
 <Route path="/admin" element={<MusicAdmin />} />
<Route path="/play/:id" element={<MusicViewer />} />
      </Routes>
      
    </div>
    </>
  );
};

export default App;